import { ActionContext, Module } from "vuex";
import { RootState } from "@/store/index";
import { BlackBoard, blackBoardApi } from "@/api/blackboards";

export interface TaskBoardState {
  blackBoards: BlackBoard[];
  projectBoards: BlackBoard[];
}

const taskboardModule: Module<TaskBoardState, RootState> = {
  namespaced: true,
  state: () =>
    ({
      blackBoards: [] as BlackBoard[],
      projectBoards: [] as BlackBoard[],
    } as TaskBoardState),
  mutations: {
    setTaskBoards(state: TaskBoardState, blackBoards: BlackBoard[]): void {
      state.blackBoards = blackBoards;
    },
    setProjects(state: TaskBoardState, projectBoards: BlackBoard[]): void {
      state.projectBoards = projectBoards;
    },
  },
  actions: {
    async listAll(
      context: ActionContext<TaskBoardState, RootState>
    ): Promise<void> {
      if (!context.state.blackBoards || context.state.blackBoards.length === 0) {
        const taskBoards = await blackBoardApi.list();
        const projects =  await blackBoardApi.listOnlyProjects();
        context.commit("setTaskBoards", taskBoards);
        context.commit("setProjects",  projects);
      }
    },
    async reloadAll(
      context: ActionContext<TaskBoardState, RootState>
    ): Promise<void> {
      const taskBoards = await blackBoardApi.list();
      const projects =  await blackBoardApi.listOnlyProjects();
      context.commit("setTaskBoards", taskBoards);
      context.commit("setProjects",  projects);
    },
    async addTaskBoard(
      context: ActionContext<TaskBoardState, RootState>,
      taskboard: BlackBoard
    ): Promise<void> {
      taskboard.id = await blackBoardApi.add(taskboard);
      const taskBoards = await blackBoardApi.list();
      const projects =  await blackBoardApi.listOnlyProjects();
      context.commit("setTaskBoards", taskBoards);
      context.commit("setProjects",  projects);
    },
    async editTaskBoard(
      context: ActionContext<TaskBoardState, RootState>,
      taskboard: BlackBoard
    ): Promise<void> {
      if (taskboard.id) {
        await blackBoardApi.edit(taskboard.id, taskboard);
        const taskBoards = await blackBoardApi.list();
        const projects =  await blackBoardApi.listOnlyProjects();
        context.commit("setTaskBoards", taskBoards);
        context.commit("setProjects",  projects);
      }
    },
    async removeTaskBoard(
      context: ActionContext<TaskBoardState, RootState>,
      id: string
    ): Promise<void> {
      if (id) {
        await blackBoardApi.delete(id);
        const taskBoards = await blackBoardApi.list();
        const projects =  await blackBoardApi.listOnlyProjects();
        context.commit("setTaskBoards", taskBoards);
        context.commit("setProjects",  projects);
      }
    },
  },
};

export default taskboardModule;
